import { detail } from '../../../../../js-handler/check-device'

const snack = require('../../../../../components/snack/snack')

export function start( detail ){ 
 
  snackBody[detail.id].start(detail)
  detail.html = snackBody[detail.id]
  snack.start(detail)

}

const snackBody = {

  error: {
    title: '',
    btn: '',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function (detail) {
      this.title = detail.text
    }
  },

  hellow: {
    title: '',
    btn: 'Undo',
    class: ``,

    dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"snack", "act":"hide"}
          ]}'`,


    start: function () {
      this.title = 'Single line messanger Single line messanger Single line messanger Single line messanger'
      this.btn = 'Undo'

    }
  },


  errorDownDtGoku: {
    title: '',
    large: false,
    btn: '',
    class: ``,
    dataDetail: ``,

    start: function (addTitle) {
      this.title = 'Error downloading item data from the server'
      this.btn = ''

      //we use this for get variable test
      if (addTitle != undefined) {
        this.title += `  ${addTitle}`
      }
    }
  },


}




